import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

/**
 * Modal mostrado cuando un usuario con rol ENCARGADO/RADIOLOGO intenta acceder
 * a una vista restringida sin haber iniciado sesión con su tarjeta NFC.
 */
@Component({
    selector: 'app-nfc-restricted-modal',
    standalone: true,
    imports: [ButtonModule],
    template: `
        <div class="flex flex-col items-center gap-3 py-3 px-2 text-center">
            <i class="pi pi-id-card" style="font-size: 2.5rem; color: var(--p-warning-color)"></i>
            <p class="font-semibold m-0">Favor Inicie sesión con su credencial para ver el contenido</p>
            <small class="text-muted-color">Inicie sesión con su tarjeta NFC para acceder a todas las funciones del sistema.</small>
            <div class="flex justify-between w-full">
                <p-button label="Ir al Dashboard" icon="pi pi-home" severity="primary" (onClick)="goDashboard()" />
                <p-button label="Cerrar" icon="pi pi-times" severity="danger" (onClick)="close()" />
            </div>
        </div>
    `
})
export class NfcRestrictedModalComponent {
    private dialogRef = inject(DynamicDialogRef);
    private router = inject(Router);

    close(): void {
        this.dialogRef.close();
    }

    goDashboard(): void {
        this.dialogRef.close();
        this.router.navigate(['/sys/dashboard']);
    }
}
